/**
 * Project definitions following engineering presentation format.
 * Each project describes: problem, approach, stack, status, and links.
 */

const projects = [
  {
    id: "pentestscan",
    title: "PentestScan",
    tagline: "Attack paths and context - not another noise scanner.",
    problem:
      "Typical scanners flood you with findings without showing what is exploitable, in what order to fix, or how issues chain. Teams need a clear view of real attack paths, not a flat list of alerts.",
    approach:
      "PentestScan links vulnerabilities into attack paths, enriches findings with exploit context, and supports modern workflows (including CI/CD gating and JWT-focused checks) so you prioritize what actually matters.",
    stack: [
      "Python 3.11",
      "FastAPI",
      "SQLite",
      "SQLAlchemy",
      "Nginx",
      "DigitalOcean",
    ],
    architecture: "Monolith with plugin-based scanner architecture. NGINX reverse proxy handles TLS termination. UniversalScanner dynamically loads scanning modules. Separate databases for auth, core data, CTI, and SIEM exports.",
    security: [
      "Session-based auth with JWT option for API",
      "TOTP 2FA with backup codes",
      "Rate limiting (5 attempts / 10 min window)",
      "CSP headers, CSRF tokens, parameterized queries",
      "Workspace isolation for tenant data separation",
    ],
    status: "Production",
    statusDetail: "Live at pentestscan.app",
    links: {
      live: "https://pentestscan.app",
      docs: "/wvs",
    },
    featured: true,
  },
  {
    id: "tcms",
    title: "TCMS",
    tagline: "Self-hosted test case management for manual QA teams",
    problem:
      "Commercial tools like TestRail ($360/month for 5 users) and Zephyr store data on vendor infrastructure, creating compliance issues for regulated industries. Legacy open-source alternatives like TestLink use outdated tech stacks (PHP, MD5 passwords) with poor UX.",
    approach:
      "Manual-first philosophy: focused feature set for what QA teams actually do daily. Modern React frontend with FastAPI backend. PostgreSQL for data portability. Full data ownership with direct database access and standard pg_dump exports. No vendor lock-in.",
    stack: [
      "React 18",
      "TypeScript",
      "FastAPI",
      "PostgreSQL",
      "SQLAlchemy",
      "Tailwind CSS",
    ],
    architecture: "SPA frontend with REST API backend. Multi-tenant hierarchy: Organization > Workspace > Project. Async SQLAlchemy for database operations. JWT authentication with bcrypt password hashing.",
    security: [
      "bcrypt password hashing (not MD5 like TestLink)",
      "JWT tokens with configurable expiry",
      "Pydantic + Zod input validation",
      "React escaping for XSS prevention",
      "Full audit trail",
    ],
    status: "Production",
    statusDetail: "v2.2.0 - MIT License",
    links: {
      live: "https://testcasesystem.com",
    },
    featured: true,
  },
  {
    id: "darkexpose",
    title: "DarkExpose SOC",
    tagline: "Threat intelligence platform with dark web and breach monitoring",
    problem:
      "Enterprise threat intelligence solutions like Recorded Future ($250K/year) and SpyCloud ($50-150K/year) are inaccessible to most organizations. HIBP API provides only breach data without dark web monitoring, Telegram OSINT, or attack surface mapping.",
    approach:
      "Integrated platform combining four capabilities: breach detection via HIBP, dark web monitoring via TOR crawler, Telegram OSINT from 40+ threat intel channels, and automated attack surface mapping. Rule-based IOC extraction with regex patterns and heuristic analysis. Enrichment via free threat feeds (OTX, AbuseIPDB, URLhaus).",
    stack: [
      "Python 3.11",
      "FastAPI",
      "PostgreSQL",
      "Telethon",
      "APScheduler",
      "requests-tor",
    ],
    architecture: "Four-layer design: Data Collection (TOR, Telegram, DNS enum) > Processing (regex IOC extraction, keyword matching) > Enrichment (threat feed APIs) > Output (dashboard, webhooks, SIEM export). Self-hosted on any Linux server.",
    security: [
      "Self-hosted: data never leaves your infrastructure",
      "TOR integration for anonymous dark web access",
      "API key management for threat feeds",
      "Multi-tenant workspace isolation",
      "Audit logging for compliance",
    ],
    status: "Development",
    statusDetail: "95% complete - Q1 2026 public release",
    links: {},
    featured: true,
  },
];

export default projects;

